import './champion-list.css'
import ChampionCard from '../champion-card/ChampionCard'

function ChampionList({ champions, imageMap, itemComponents, itemImageMap }) {
  return (
    <div className="champion-list">
      {champions.map((champ, index) => (
        <ChampionCard
          key={index}
          champion={champ}
          imageMap={imageMap}
          itemComponents={itemComponents}
          itemImageMap={itemImageMap}
        />
      ))}
    </div>
  )
}

export default ChampionList
